import { useSession } from "@/component/SessionProvider";
import Link from "next/link";
import { useEffect, useState } from "react";

import { UserCircleIcon } from "@heroicons/react/16/solid";
export const Profile = () => {
  const { session, signOut } = useSession();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const isEmailVerified = session.user?.emailVerified;

  const toggleDropdown = () => setIsOpen(!isOpen);

  // TODO - refactor to use css solution later
  useEffect(() => {
    const isOpenHandler = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", isOpenHandler);
    return () => {
      document.removeEventListener("click", isOpenHandler);
    };
  }, [isOpen]);

  return (
    <div className="relative flex justify-center">
      <button
        onClick={toggleDropdown}
        className="flex capitalize items-center text-sm pe-1 font-medium rounded-full md:me-0 focus:ring-4 focus:ring-slate-800 text-white"
        type="button"
      >
        <span className="sr-only">Open user menu</span>
        {/* <img
          className="w-8 h-8 me-2 rounded-full"
          src={UserCircleIcon}
          src="https://media.istockphoto.com/id/1327592506/vector/default-avatar-photo-placeholder-icon-grey-profile-picture-business-man.jpg?s=612x612&w=0&k=20&c=BpR0FVaEa5F24GIw7K8nMWiiGmbb8qmhfkpXcp1dhQg="
          alt="user photo"
        /> */}
        <UserCircleIcon className="w-8 h-8 me-2 rounded-full" />
        {session.user?.name}
        <svg
          className="w-2.5 h-2.5 ms-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 10 6"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 4 4 4-4"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="z-10 absolute left-auto top-full top-off mt-2 sm:right-0 divide-y divide-slate-700 rounded-lg shadow w-44 bg-gray-900 dark:bg-gray-700 dark:divide-gray-600">
          <div className="px-4 py-3 text-sm text-white">
            <div className="font-medium text-appPrimary">
              {!isEmailVerified && "Unverified Email"}
            </div>
            <div className="truncate">{session.user?.email}</div>
          </div>
          <ul
            className="py-2 text-sm"
            aria-labelledby="dropdownInformdropdownAvatarNameButtonationButton"
          >
            {/* <li>
              <Link
                href="/dashboard"
                className="block px-4 py-2 hover:bg-gray-800 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                Dashboard
              </Link>
            </li> */}

            {/* <li>
              <Link
                href="/dashboard"
                className="block px-4 py-2 hover:bg-gray-800 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                Dashboard
              </Link>
            </li> */}
            <li>
              <Link
                href="/dashboard/referrals"
                className="block px-4 py-2 hover:bg-gray-800 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                Referrals
              </Link>
            </li>
            {session.user?.isAdmin && (
              <li>
                <Link
                  href="/admin/dashboard"
                  className="block px-4 py-2 hover:bg-gray-800 dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  Admin Dashboard
                </Link>
              </li>
            )}
            {/* <li>
              <a
                href="#"
                className="block px-4 py-2 hover:bg-gray-800 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                Earnings
              </a>
            </li> */}
            <li className="max-[991px]:hidden">
              <Link
                href="/dashboard/account/settings"
                className="block px-4 py-2 hover:bg-gray-800 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                Account Settings
              </Link>
            </li>
          </ul>
          <div className="py-2">
            <a
              href="#"
              onClick={signOut}
              className="block px-4 py-2 text-sm dark:text-gray-200 dark:hover:text-white"
            >
              Sign out
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
